export default "__VITE_ASSET__oU2MfNmiinDkSCholg0BRg__"